// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class ProductionRole extends TrackingModel {
	public ProductionRoleId: number = 0;
	public ProductionId: number = 0;
	public Name: string = "";
	public Description?: string;
}